/* eslint-disable
jsx-a11y/anchor-is-valid,
max-len,
react/no-did-update-set-state,
react/no-unused-prop-types */
import Promise from 'bluebird';
import React from 'react';
import PropTypes from 'prop-types';
import {
  noop, result, compact, defaults, extend, each, isArray, size, any, isUndefined, isEmpty,
} from 'underscore';

import { withPerfMarker } from '@bingads-webui/performance-marker-react-wrapper';
import { DropdownSelector } from '@bingads-webui-react/dropdown-selector';
import { UiBlocker } from '@bingads-webui-react/ui-blocker';
import { Dialog, DialogFooter, PrimaryButton, DefaultButton, MessageBar, MessageBarType } from '@bingads-webui-react/fabric-control';
import { LearnMoreLink } from '@bingads-webui-campaign-react/help';
import { Panel } from '@bingads-webui-campaign-react/panel';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { PillControl } from '@bingads-webui-react/pill-control';
import { MediaRepository } from '@bingads-webui-campaign/media-repository';
import { getAdCreatorInstrumentation } from '@bingads-webui-campaign/ad-creator-tools-instrumentation';
import { withInstrumentation } from '@bingads-webui-react/hoc-with-instrumentation';
import { deserializeImageAssetMetadata } from '@bingads-webui-campaign/media-metadata-model';
import { extendPath, getUrlProtocolAndDomain } from '@bingads-webui/url-util';
import { ThumbsUpDown } from '@bingads-webui-campaign-react/thumbs-up-down';
import { getAddImageStyle } from '@bingads-webui-campaign/shared-image-experience-styles';
import {
  ImageFilePicker,
  UploadPreview,
  updateProgress,
  updateFilePreviewArrayUploadProgress,
  generatePreviewArray,
} from '@bingads-webui-campaign-react/upload-file-picker';
import { StockImageFilter } from '@bingads-webui-campaign-react/stock-image-filter';

import AspectRatioChoiceGroup from './aspect-ratio-choice-group';
import StockImagePickerContainer from './stock-image/stock-image-picker-container';
import UserImagePickerContainer from './user-image/user-image-picker-container';
import ImageSuggestionPickerContainer from './image-suggestion/image-suggestion-picker-container';
import SocialMediaPickerContainer from './social-media-image/social-media-picker-container';
import { Modal } from '../components/modal';
import getCroppedImage from '../util/get-cropped-image';
import { getSmartCroppedImagesAsync } from '../util/get-smart-cropped-image';
import { newImageFromMTObject, ImageExperienceImage } from '../model/image-experience-image';
import {
  ImageSizeValidationError,
  ImageLoadError,
  validateImageSizeAsync,
  validateImageWithDimension,
} from '../util/image-size-validation';
import { initializeStockPhotoDataSource } from './data-source/stock-photo-data-source';
import { initializeUserPhotoDataSource } from './data-source/user-photo-data-source';
import { initializeImageSuggestionsDataSource } from './data-source/image-suggestions-data-source';
import C from '../constants';
import SearchBox from '../components/search-box';
import { getImageValidationErrorMessage } from '../util/image-validation-handling';
import { ImageRepository } from '../util/image-repository';
import SocialMediaRepository from '../util/social-media-repository';

const pillControlTypes = {
  existingImages: 'existingImages',
  stockImages: 'stockImages',
  websiteSuggestions: 'websiteSuggestions',
  socialMediaImages: 'socialMediaImages',
  upload: 'upload',
};

class AddImage extends React.PureComponent {
  constructor(props) {
    super(props);

    const {
      i18n,
      aid,
      cid,
      oDataConfig,
      imageType,
      isStockPhotoEnabled,
      isMultimediaAd,
      isImageExtension,
      isMultimediaAdinMSANEnabled,
      isMMAV2Enabled,
      isCombinedMsanAndMmaAspectRatios,
      isPMaxAspectRatiosV2Enabled,
      imageOption,
      setProcessExternalImageCallback,
    } = this.props;

    this.imageRepository = new ImageRepository(cid, aid, oDataConfig);
    this.socialMediaRepository = new SocialMediaRepository({ cid, aid, oDataConfig });

    this.sortBySelectionItems = [
      {
        id: C.sortBySelections.recentUpload.id,
        value: i18n.getString('ImageExperience_Sort_Recent_Upload'),
      },
      {
        id: C.sortBySelections.imageText.id,
        value: i18n.getString('ImageExperience_Sort_Image_Text'),
      },
    ];

    this.initializePillItems();

    this.userPhotoDataSource = initializeUserPhotoDataSource({
      imageType,
      imageRepository: this.imageRepository,
    });

    if (isStockPhotoEnabled) {
      this.stockPhotoDataSource = initializeStockPhotoDataSource(cid, aid, oDataConfig, imageType, isMultimediaAd, imageOption);
    }

    this.pillControlIndexToDataSource = [
      this.userPhotoDataSource,
      this.stockPhotoDataSource,
    ];

    this.defaultState = {
      sortBySelection: this.sortBySelectionItems[0],
      blockUi: false,
      errors: [],
      pillControlValue: pillControlTypes.existingImages,
      pillControlIndex: 0,
      userPhotoInitialized: false,
      searchValue: '',
      selectedImage: null,
      blockSuggestionImagePickerOnly: false,
      previewImageArr: [],
      uploadImageInfo: [],
      hasRendered: false,
      subdomain: null,
      fullUrlWithSubdomain: null,
      forceInternalScrapingService: false,
    };

    this.imageSelectPerfMarker = this.props.perfMarker.createChild('existingImageSelect');

    this.state = this.defaultState;
    this.dialogRef = React.createRef();

    this.enableNewFilePicker = isMultimediaAd || isMultimediaAdinMSANEnabled || isImageExtension;
    this.isMMAV2Enabled = isMMAV2Enabled;
    this.isCombinedMsanAndMmaAspectRatios = isCombinedMsanAndMmaAspectRatios;
    this.isPMaxAspectRatiosV2Enabled = isPMaxAspectRatiosV2Enabled;

    setProcessExternalImageCallback(this.onImageSelectedByUrl.bind(this));
  }

  componentDidMount() {
    if (this.props.preDefinedFilter) {
      const datasource = this.getDataSource();
      if (datasource) {
        datasource.searchAsync(null, this.state.sortBySelection.id, this.props.preDefinedFilter);
      }
    } else if (this.props.shouldShowContentOnly) {
      const datasource = this.getDataSource();
      /* istanbul ignore else */
      if (datasource) {
        datasource.searchAsync(null, this.state.sortBySelection.id);
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.shouldShowContentOnly) {
      return;
    }

    if (prevProps.isFinalUrlImageRetrievalEnabled !== this.props.isFinalUrlImageRetrievalEnabled) {
      this.initializePillItems();
    }

    if (!this.props.isImageSelectorDisplayed) {
      if (this.state.forceInternalScrapingService) {
        // reset image suggestions to full domain search
        this.props.suggestionPoller.getLandingPageSuggestions({
          landingPageUrl: this.props.finalUrl,
          enableOfflinePollingDelay: false,
          forceInternalScrapingService: false,
          minimumResolution: {
            width: this.minimumSize[0],
            height: this.minimumSize[1],
          },
        });
      }

      this.setState(this.defaultState);
    }
    if (!prevState.hasRendered && this.props.isImageSelectorDisplayed) {
      this.setState({
        hasRendered: true,
        pillControlIndex: prevProps.defaultSelectedPill,
        pillControlValue: this.pillControlItems[prevProps.defaultSelectedPill].value,
      });
    }
    if (!prevProps.isImageSelectorDisplayed && this.props.isImageSelectorDisplayed && !this.props.isChooseThumbnail) {
      const datasource = this.getDataSource();
      /* istanbul ignore else */
      if (datasource) {
        datasource.searchAsync(null, this.state.sortBySelection.id, this.props.preDefinedFilter);
      }
    }
  }

  onImageSearch = (searchValue) => {
    this.setState(
      { searchValue },
      () => {
        this.getDataSource().searchAsync(this.state.searchValue, this.state.sortBySelection.id, this.props.preDefinedFilter);
      }
    );
  };

  onSortBySelect = (sortBySelection) => {
    this.setState(
      { sortBySelection },
      () => {
        this.getDataSource().searchAsync(this.state.searchValue, this.state.sortBySelection.id, this.props.preDefinedFilter);
      }
    );
  };

  onThumbnailSelected = (selectedImage) => {
    this.setState({ selectedImage });
    this.showUiBlocker(false);
  };

  onImageSelected = (selectedImage, source) => {
    const {
      i18n,
      onSelectedImagesSet,
      imageType,
      isMultimediaAd,
      isMultimediaAdinMSANEnabled,
      isChooseThumbnail,
      isAdCreatorEnabled,
      mediaRepository,
      imageOption,
      aspectRatioOption,
      isMMAV2Enabled,
      isCombinedMsanAndMmaAspectRatios,
      isStoreAppProng,
      isStoreAppSpotLight,
      isStoreAppTransparentLogo,
      isLinkedInAd,
      isPMaxAspectRatiosV2Enabled,
    } = this.props;

    this.showUiBlocker(true);

    this.imageSelectPerfMarker.willInit();
    this.props.activityLogger.signal(selectedImage.Source, 'image selected from user image');

    const imageTypeToCheck = imageOption === C.imageOptionKeys.Logo ? aspectRatioOption : imageType;

    const createImageObjectPromise = new Promise((resolve, reject) => {
      const imageValidationError =
        validateImageWithDimension(
          selectedImage.Width,
          selectedImage.Height,
          imageTypeToCheck,
          isMultimediaAd,
          imageOption,
          isMMAV2Enabled,
          isCombinedMsanAndMmaAspectRatios,
          false /* isDisplayAds */,
          false /* isPortraitImage */,
          isStoreAppProng,
          isStoreAppSpotLight,
          isStoreAppTransparentLogo,
          false /* isUnifiedAppCampaignWindowsStore */,
          isLinkedInAd,
          isPMaxAspectRatiosV2Enabled
        );

      if (imageValidationError) {
        reject(imageValidationError);
      }
      const useBaseImageInfo = isAdCreatorEnabled && selectedImage.OriginalUrl;
      const model = newImageFromMTObject(extend({}, selectedImage, useBaseImageInfo && {
        Id: selectedImage.BaseIdString,
        IdString: selectedImage.BaseIdString,
        Url: selectedImage.OriginalUrl,
      }), source);

      resolve(model);
    });

    const generateAspectRatiosPromise = (imageToCrop) => {
      if (isAdCreatorEnabled) {
        const { smartCropActivity } =
          getAdCreatorInstrumentation(this.props.instrumentation, this.props.adCreatorScenario);

        return getSmartCroppedImagesAsync({
          mediaRepository,
          originalImageToCrop: imageToCrop,
          smartCropActivity,
          isMultimediaAd,
          isMultimediaAdinMSANEnabled,
          imageOption: this.props.imageOption,
          aspectRatioOption: this.props.aspectRatioOption,
          isMMAV2Enabled,
          isCombinedMsanAndMmaAspectRatios,
          isStoreAppProng,
          isStoreAppSpotLight,
          isStoreAppTransparentLogo,
          isLinkedInAd,
          isPMaxAspectRatiosV2Enabled,
        }).then((smartCroppedImages) => {
          const { effectSettings } = deserializeImageAssetMetadata(selectedImage.Metadata) || {};

          // set default image level effect if metadata exists
          if (effectSettings) {
            const effectSettingsModel = defaults({ effectSrc: selectedImage.Url }, effectSettings);

            each(smartCroppedImages, (placement) => {
              placement.BaseImage.setEffectSettings(effectSettingsModel);
              placement.setEffectSettings(effectSettingsModel);
            });
          }

          return smartCroppedImages;
        });
      }

      return getCroppedImage({
        originalImageToCrop: imageToCrop,
        isMultimediaAd,
        isMultimediaAdinMSANEnabled,
        imageOption: this.props.imageOption,
        aspectRatioOption: this.props.aspectRatioOption,
        isMMAV2Enabled,
        isCombinedMsanAndMmaAspectRatios,
        isStoreAppProng,
        isStoreAppSpotLight,
        isStoreAppTransparentLogo,
        isLinkedInAd,
      });
    };

    createImageObjectPromise.then((imgObj) => {
      if (isChooseThumbnail) {
        return imgObj;
      }

      return generateAspectRatiosPromise(imgObj);
    }).then((imagesSet) => {
      onSelectedImagesSet(imagesSet);
    }).catch((e) => {
      const error = getImageValidationErrorMessage(e, i18n);

      this.showErrors([error]);
    }).finally(() => {
      this.imageSelectPerfMarker.done({ imageWidth: selectedImage.Width, imageHeight: selectedImage.height });

      this.showUiBlocker(false);
    });
  };

  onNewImage = ({
    recoverFromImageLoadError = false,
    imageSource,
    saveImagePromise,
    source,
  }) => {
    const {
      i18n,
      onSelectedImagesSet,
      imageType,
      isMultimediaAdinMSANEnabled,
      isMultimediaAd,
      isChooseThumbnail,
      mediaRepository,
      isAdCreatorEnabled,
      imageOption,
      aspectRatioOption,
      isMMAV2Enabled,
      isCombinedMsanAndMmaAspectRatios,
      isStoreAppProng,
      isStoreAppSpotLight,
      isStoreAppTransparentLogo,
      isLinkedInAd,
      isPMaxAspectRatiosV2Enabled,
    } = this.props;

    const imageSourcesArr = isArray(imageSource) ? imageSource : [imageSource];
    const handlePromiseArr = [];

    if (this.enableNewFilePicker) {
      const { uploadImageInfo } = this.state;
      const previewImageArr = generatePreviewArray({ files: uploadImageInfo, fileSources: imageSourcesArr });
      this.setState({
        previewImageArr,
      });
    } else {
      this.showUiBlocker(true);
    }

    const curMaxUploadNum = this.getMaxUploadNum();
    const uploadNum = Math.min(curMaxUploadNum, imageSourcesArr.length);
    const imageTypeToCheck = imageOption === C.imageOptionKeys.Logo ? aspectRatioOption : imageType;

    for (let i = 0; i < uploadNum; i += 1) {
      const imageData = imageSourcesArr[i];
      const handlePromise = (() => {
        let preValidationFailed = false;

        return validateImageSizeAsync(imageData, imageTypeToCheck, isMultimediaAd, imageOption, isMMAV2Enabled, isCombinedMsanAndMmaAspectRatios, false /* isDisplayAds */, false /* isPortraitImage */, isStoreAppProng, isStoreAppSpotLight, isStoreAppTransparentLogo).bind(this)
          .catch((e) => {
            if (recoverFromImageLoadError && e instanceof ImageLoadError) {
              // Sometimes loading image from other website may fail because of http code 403.
              // Give it a chance to try backend API to see if it can saved
              preValidationFailed = true;
              return;
            }

            throw e;
          })
          .then(() => {
            let inProgress;
            if (this.enableNewFilePicker) {
              inProgress = updateProgress({
                setProgress: this.setUploadProgress.bind(this),
                index: i,
              });
            }
            return saveImagePromise(imageData, inProgress);
          })
          .then(id => this.imageRepository.getImageByIdAsync(id))
          .then((imgObjMT) => {
            const imgObj = newImageFromMTObject(imgObjMT, source);
            const postValidationError = validateImageWithDimension(
              imgObj.Width,
              imgObj.Height,
              imageTypeToCheck,
              isMultimediaAd,
              imageOption,
              isMMAV2Enabled,
              isCombinedMsanAndMmaAspectRatios,
              false /* isDisplayAds */,
              false /* isPortraitImage */,
              isStoreAppProng,
              isStoreAppSpotLight,
              isStoreAppTransparentLogo,
              false /* isUnifiedAppCampaignWindowsStore */,
              isLinkedInAd,
              isPMaxAspectRatiosV2Enabled
            );

            /* istanbul ignore else */
            if (postValidationError) {
              postValidationError.isDueToResizing = !preValidationFailed;

              throw postValidationError;
            }
            if (isChooseThumbnail) {
              return imgObj;
            }

            if (this.enableNewFilePicker) {
              this.setUploadProgress(i, 1);
            }

            if (isAdCreatorEnabled) {
              const { smartCropActivity } =
              getAdCreatorInstrumentation(this.props.instrumentation, this.props.adCreatorScenario);

              return getSmartCroppedImagesAsync({
                mediaRepository,
                originalImageToCrop: imgObj,
                smartCropActivity,
                isMultimediaAd,
                isMultimediaAdinMSANEnabled,
                imageOption: this.props.imageOption,
                aspectRatioOption: this.props.aspectRatioOption,
                isMMAV2Enabled: this.isMMAV2Enabled,
                isCombinedMsanAndMmaAspectRatios: this.isCombinedMsanAndMmaAspectRatios,
                isStoreAppProng,
                isStoreAppSpotLight,
                isStoreAppTransparentLogo,
                isLinkedInAd,
                isPMaxAspectRatiosV2Enabled,
              });
            }
            const croppedImages = getCroppedImage({
              originalImageToCrop: imgObj,
              isMultimediaAd,
              isMultimediaAdinMSANEnabled,
              imageOption: this.props.imageOption,
              aspectRatioOption: this.props.aspectRatioOption,
              isMMAV2Enabled: this.isMMAV2Enabled,
              isCombinedMsanAndMmaAspectRatios,
            });

            return croppedImages;
          });
      })();

      handlePromiseArr.push(handlePromise);
    }

    return Promise.all(handlePromiseArr)
      .then((imgObjArr) => {
        if (imgObjArr.length === 1) {
          onSelectedImagesSet(imgObjArr[0]);
        } else {
          onSelectedImagesSet(imgObjArr);
        }
      })
      .catch((e) => {
        let errorMessage;

        if (e instanceof ImageSizeValidationError) {
          let stringTemplateKey = 'ImageExperience_SizeValidationFailTemplate';
          /* istanbul ignore else */
          if (e.isDueToResizing) {
            stringTemplateKey = 'ImageExperience_SizeValidationFailTemplate_WithDetail';
          }

          if (isAdCreatorEnabled) {
            stringTemplateKey = 'ImageExperience_MultipleUpload_SizeValidationFailTemplate';
          }

          errorMessage = i18n.getString(stringTemplateKey, { width: e.minWidth, height: e.minHeight });
        } else {
          const error = result(e, 'message', '');
          const errorMsg = i18n.getString(`ImageExperience_Error_${error}`);

          /* istanbul ignore if */
          if (isUndefined(errorMsg)) {
            const { websiteSuggestionActivity } =
              getAdCreatorInstrumentation(this.props.instrumentation, this.props.adCreatorScenario);
            websiteSuggestionActivity.trace(`Unmapped error code: ${error}`);
          }

          errorMessage =
            errorMsg || i18n.getString('ImageExperience_Error_GenericUploadErrorMessage') || error;
        }

        this.showErrors([errorMessage]);

        return { errorMessage };
      })
      .finally(() => {
        this.showUiBlocker(false);
        this.setState({
          previewImageArr: [],
        });
      });
  };

  onImageSelectedByUrl = (url, imageSource = C.imageSources.Website) => {
    this.showUiBlocker(true);

    let sourceType;
    if (imageSource === C.imageSources.Website) {
      sourceType = C.sourceTypes.WebsiteImported;
    } else if (C.sourceTypes[imageSource]) {
      sourceType = imageSource;
    }

    const saveImagePromise = () =>
      this.imageRepository.bulkSaveImagesByUrl([{ url, sourceType }])
        .then((ids) => {
          const hasError = any(ids, id => id && id.code);

          if (hasError) {
            const error = compact(ids);
            throw new Error(error[0].code);
          }

          return ids[0];
        });

    return this.onNewImage({
      recoverFromImageLoadError: true,
      imageSource: url,
      saveImagePromise,
      source: imageSource,
    }).finally(() => {
      this.showUiBlocker(false);
    });
  };

  onFileRead = (multipleImageSources) => {
    if (this.props.isAdCreatorEnabled) {
      const { fileUploadActivity } =
        getAdCreatorInstrumentation(this.props.instrumentation, this.props.adCreatorScenario);
      const selectedFilesCount = isArray(multipleImageSources) ? size(multipleImageSources) : 1;

      fileUploadActivity.trace(`Selected ${selectedFilesCount} local files`);
    }

    const onUploadStart = this.props.onUploadStart || noop;
    const onUploadComplete = this.props.onUploadComplete || noop;

    const saveImagePromise = (imageSource, inProgress = null) =>
      this.imageRepository.uploadImageAsync(imageSource, null, inProgress, this.props.imageOption)
        .then((response) => {
          /* istanbul ignore if */
          if (!response || !response.imageId) {
            throw new Error(response && response[0] && response[0].Code);
          }

          return response.imageId;
        });

    onUploadStart({ imageSource: multipleImageSources });

    return this.onNewImage({
      imageSource: multipleImageSources,
      saveImagePromise,
      source: C.imageSources.Upload,
    }).finally(() => {
      onUploadComplete();
    });
  };

  onPillChange = ({ index, value }) => {
    this.props.activityLogger.signal(value, 'old image tab clicked');

    this.setState({
      pillControlValue: value,
      pillControlIndex: index,
    });
    // We need reset select status in thumbnail mode
    /* istanbul ignore next */
    if (this.props.isChooseThumbnail) {
      this.setState({
        selectedImage: null,
      });
    }
  };

  onFileSelected = (fileObjectArr) => {
    this.setState({
      uploadImageInfo: fileObjectArr,
    });
  };

  /* istanbul ignore next */
  onKeyboardEscapeFromImage = (event) => {
    const cancelButton = document.querySelector('.add-image-cancel-button');
    cancelButton.focus();

    event.stopPropagation();
    event.preventDefault();
  };

  getMaxUploadNum = () => {
    const imageListLength = isArray(this.props.imageList) ? this.props.imageList.length : 0;

    if (this.props.maxUploadNum >= 0) {
      return this.props.maxUploadNum - imageListLength;
    }

    return (this.props.imageOption === C.defaultImageOption ?
      C.DEFAULT_MAX_IMAGE : C.DEFAULT_MAX_LOGO) - imageListLength;
  };

  setUploadProgress = (index, progress) => {
    this.setState(updateFilePreviewArrayUploadProgress(index, progress));
  };

  getDataSource = () => this.pillControlIndexToDataSource[this.state.pillControlIndex];

  shouldEnableWebsiteSuggestion() {
    const {
      isAdCreatorEnabled,
      isFinalUrlImageRetrievalEnabled,
    } = this.props;
    return (isAdCreatorEnabled || isFinalUrlImageRetrievalEnabled);
  }

  initializePillItems() {
    const {
      i18n,
      imageType,
      isMultimediaAd,
      imageOption,
      permissions,
      isChooseThumbnail,
      hideStockPillControl,
    } = this.props;

    const showWebsiteSuggestion = this.shouldEnableWebsiteSuggestion();

    this.pillControlItems = compact([
      {
        name: i18n.getString('ImageExperience_Existing_Images'),
        href: '#',
        value: pillControlTypes.existingImages,
      },
      !hideStockPillControl && {
        name: i18n.getString('ImageExperience_Stock_Images'),
        href: '#',
        value: pillControlTypes.stockImages,
      },
      showWebsiteSuggestion && {
        name: i18n.getString('ImageExperience_Website_Suggestions'),
        href: '#',
        value: pillControlTypes.websiteSuggestions,
        labelString: i18n.getString('ImageExperience_New'),
      },
      permissions.IsSocialMediaImagesEnabled && {
        name: i18n.getString(_TL_('Social Media images')),
        href: '#',
        value: pillControlTypes.socialMediaImages,
        labelString: i18n.getString('ImageExperience_New'),
      },
      !isChooseThumbnail && {
        name: i18n.getString('ImageExperience_Upload'),
        href: '#',
        value: pillControlTypes.upload,
      },
    ]);

    // need to set data source when image suggestion is re-enabled during component update
    if (showWebsiteSuggestion) {
      this.minimumSize = C.getMinimumSizeForImage(imageType, isMultimediaAd, imageOption);

      this.imageSuggestionDataSource = initializeImageSuggestionsDataSource({
        loadMoreByPageNumber: (pageNumber) => {
          const landingPageUrl = this.state.fullUrlWithSubdomain || this.props.finalUrl;

          return this.props.suggestionPoller.getMoreLandingPageSuggestions({
            landingPageUrl,
            pageNumber,
            forceInternalScrapingService: this.state.forceInternalScrapingService,
            minimumResolution: {
              width: this.minimumSize[0],
              height: this.minimumSize[1],
            },
          });
        },
      });
    }
  }


  showErrors = errors => this.setState({ errors });

  showUiBlocker = shouldBlock => this.setState({ blockUi: shouldBlock });

  isStockImages = () => this.props.isStockPhotoEnabled && this.state.pillControlIndex === 1;

  render() {
    const {
      i18n,
      isForVNext,
      staticImagePath,
      onSelectedImagesSet,
      imageType,
      isStockPhotoEnabled,
      isLazyLoadEnabled,
      permissions,
      isChooseThumbnail,
      getContainer,
      imageList,
      isMultimediaAdinMSANEnabled,
      isAdCreatorEnabled,
      isLogoEnabled,
      shouldShowContentOnly,
      imageOption,
      aspectRatioOption,
    } = this.props;

    const {
      pillControlIndex,
      pillControlValue,
      sortBySelection,
      previewImageArr,
    } = this.state;

    const shouldShowPillControl = isStockPhotoEnabled;
    const shouldShowExistingImagePicker = !isStockPhotoEnabled ||
      (isStockPhotoEnabled && pillControlValue === pillControlTypes.existingImages);
    const shouldShowStockImagePicker = isStockPhotoEnabled &&
      pillControlValue === pillControlTypes.stockImages;
    const shouldShowSearchBox = !isStockPhotoEnabled ||
      (isStockPhotoEnabled && pillControlValue !== pillControlTypes.websiteSuggestions);
    const shouldShowSortBy = !isStockPhotoEnabled ||
      (isStockPhotoEnabled && pillControlValue === pillControlTypes.existingImages);
    const shouldShowFilePicker = !isStockPhotoEnabled ||
      (isStockPhotoEnabled && pillControlValue === pillControlTypes.upload);
    const shouldShowSuggestionPicker = isStockPhotoEnabled && pillControlValue === pillControlTypes.websiteSuggestions;

    const shouldShowSocialMediaImagePicker = pillControlValue === pillControlTypes.socialMediaImages;

    let smartCropActivity = {
      trace: noop,
    };
    let feedbackActivity = {
      trace: noop,
    };
    const finalUrlDomain = getUrlProtocolAndDomain(this.props.finalUrl || '');

    if (shouldShowSuggestionPicker) {
      const { websiteSuggestionActivity } =
        getAdCreatorInstrumentation(this.props.instrumentation, this.props.adCreatorScenario);

      websiteSuggestionActivity.trace('User opened website suggestions');
    }

    if (isAdCreatorEnabled) {
      smartCropActivity = getAdCreatorInstrumentation(this.props.instrumentation, this.props.adCreatorScenario).smartCropActivity; // eslint-disable-line prefer-destructuring, max-len
      feedbackActivity = getAdCreatorInstrumentation(this.props.instrumentation, this.props.adCreatorScenario).feedbackActivity; // eslint-disable-line prefer-destructuring, max-len
    }

    const addImageLabelText = () => (imageType ?
      i18n.getString('ImageExperience_ReplaceImageTitle') :
      i18n.getString(`ImageExperience_Add${imageOption}Title`));

    const addImageContent = () => (
      <div className="add-image-content">
        {!isForVNext &&
          <div className="add-image-label">
            {addImageLabelText()}
          </div>}
        <div className="add-image-description">
          <span>
            {this.shouldEnableWebsiteSuggestion() ?
            i18n.getString(`ImageExperience_Add${imageOption}Description`) :
            i18n.getString(_TL_('Choose from your existing uploaded images, stock images, or upload a new file.'))}
          </span>
          {this.props.isAudienceAd && <LearnMoreLink
            linkText={i18n.getString('ImageExperience_BestPracticeHelp')}
            topic="app54659"
          />}
        </div>
        {!isForVNext && <button
          className="close-dialog-button glyphicon glyphicon-remove"
          onClick={this.props.onImageSelectionCanceled}
        />}
        {
          shouldShowPillControl &&
          <PillControl
            className={`pill-control ${previewImageArr.length > 0 ? 'disable-mouse' : ''}`}
            defaultSelectedIndex={pillControlIndex}
            onItemChange={({ name, value, index }) => this.onPillChange({ name, value, index })}
            items={this.pillControlItems}
          />
        }
        <div className="clearfix existing-images">
          {
            shouldShowSearchBox &&
            <div className={pillControlIndex === 0 ? 'user-image-search-box' : 'user-image-search-box hide'}>
              <SearchBox
                onSearch={this.onImageSearch}
                searchBoxPlacedHolderText={i18n.getString('ImageExperience_Search_Placeholder')}
                searchBoxAriaLabel={i18n.getString('ImageExperience_Search_Placeholder')}
              />
            </div>
          }
          {
            shouldShowSearchBox &&
            <div className={pillControlIndex === 1 ? 'stock-image-search-box' : 'stock-image-search-box hide'}>
              <SearchBox
                onSearch={this.onImageSearch}
                searchBoxPlacedHolderText={i18n.getString('ImageExperience_Stock_Search_Placeholder')}
                searchBoxAriaLabel={i18n.getString('ImageExperience_Stock_Search_Placeholder')}
                query={isEmpty(this.props.recommendationStockImages) ? undefined : this.props.recommendationStockImages.Query}
              />
            </div>
          }
          {
            shouldShowSortBy &&
            <div>
              <div className="dropdown-selector-container">
                <DropdownSelector
                  totalCount={2}
                  i18n={i18n}
                  selectedItem={sortBySelection}
                  onSelect={this.onSortBySelect}
                  mode="simple"
                  items={this.sortBySelectionItems}
                  dropdownMenuAriaLabel={i18n.getString('ImageExperience_SortBy')}
                  enableArrowKeysSupport={this.props.isForVNext}
                  shouldFocusFirstFocusableItemOnMount
                />
              </div>
              <span className="sort-by-label">
                {i18n.getString('ImageExperience_SortBy')}
              </span>
            </div>
          }
        </div>
        {
          shouldShowStockImagePicker && permissions.IsStockPhotoFilterEnabled &&
          <div className="shutter-stock-filter-container">
            <StockImageFilter
              i18n={i18n}
              i18nLegacy={i18n}
              isForVNext={isForVNext}
              onFilterQueryChange={
                filterQuery => this.stockPhotoDataSource.updateFilterQuery(filterQuery)
              }
            />
          </div>
        }
        {
          shouldShowExistingImagePicker &&
          <React.Fragment>
            {
              this.shouldEnableWebsiteSuggestion() &&
              <div className="alert alert-info existing-opt-in-disclaimer">
                <div className="alert-image" />
                <div className="alert-info-inline">
                  <span>
                    {i18n.getString('AdCreator_WebsiteImage_OptIn_DisclaimerPartOne')}
                  </span>
                  <a
                    target="_blank"
                    className="btn-link middle-info"
                    rel="noopener noreferrer"
                    href="https://about.ads.microsoft.com/en-us/resources/policies/microsoft-advertising-agreement"
                  >
                    <span>{i18n.getString('AdCreator_WebsiteImage_OptIn_DisclaimerPartTwo')}</span>
                  </a>
                  <span>
                    {i18n.getString('AdCreator_WebsiteImage_OptIn_DisclaimerPartThree')}
                  </span>
                  <a
                    target="_blank"
                    className="btn-link"
                    rel="noopener noreferrer"
                    href="https://about.ads.microsoft.com/en-us/resources/policies/image-audio-and-video-policies"
                  >
                    <span>{i18n.getString('ImageExperience_Review_Image_Policy')}</span>
                  </a>
                </div>
              </div>
            }
            <UserImagePickerContainer
              imageType={imageType}
              showUiBlocker={this.showUiBlocker}
              imageRepository={this.imageRepository}
              showErrors={this.showErrors}
              staticImagePath={staticImagePath}
              userPhotoDataSource={this.userPhotoDataSource}
              onImageSelected={image => this.onImageSelected(image, C.imageSources.Existing)}
              isForVNext={isForVNext}
              isLazyLoadEnabled={isLazyLoadEnabled}
              i18n={i18n}
              imageList={imageList}
              isAdCreatorEnabled={this.props.isAdCreatorEnabled}
              isAudienceAd={this.props.isAudienceAd}
              onKeyboardEscapeFromImage={this.onKeyboardEscapeFromImage}
            />
          </React.Fragment>
        }
        {
          shouldShowStockImagePicker &&
          <React.Fragment>
            <div className="alert alert-info" style={{ margin: '3px 0' }}>
              <div className="alert-image" />
              <div className="alert-info-inline">
                {i18n.getString('ImageExperience_ShutterStock_Disclaimer_Watermark')}
              </div>
            </div>
            <div className="alert alert-info">
              <div className="alert-image" />
              <div className="alert-info-inline">
                <span>
                  {i18n.getString('ImageExperience_ShutterStock_Disclaimer_Image_Policy')}
                </span>
                <span>&nbsp;</span>
                <a
                  className="HelpTopic btn-link"
                  query="app54718"
                  rel="noopener noreferrer"
                >
                  <span>{i18n.getString('ImageExperience_Review_Image_Policy')}</span>
                </a>
              </div>
            </div>
          </React.Fragment>
        }
        {
          shouldShowStockImagePicker &&
          <StockImagePickerContainer
            imageType={imageType}
            showUiBlocker={this.showUiBlocker}
            imageRepository={this.imageRepository}
            showErrors={this.showErrors}
            onSelectedImagesSet={onSelectedImagesSet}
            staticImagePath={staticImagePath}
            stockPhotoDataSource={this.stockPhotoDataSource}
            isMultimediaAdinMSANEnabled={isMultimediaAdinMSANEnabled}
            isForVNext={isForVNext}
            isMultimediaAd={this.props.isMultimediaAd}
            permissions={this.props.permissions}
            perfMarker={this.props.perfMarker.createChild('stockImagePicker')}
            i18n={i18n}
            isAdCreatorEnabled={this.props.isAdCreatorEnabled}
            mediaRepository={this.props.mediaRepository}
            smartCropActivity={smartCropActivity}
            imageOption={imageOption}
            aspectRatioOption={aspectRatioOption}
            onKeyboardEscapeFromImage={this.onKeyboardEscapeFromImage}
            onSelectStockImage={this.props.onSelectStockImage}
          />
        }
        {
          shouldShowSuggestionPicker &&
          <ImageSuggestionPickerContainer
            suggestion={this.props.suggestion}
            dataSource={this.imageSuggestionDataSource}
            i18n={i18n}
            setUiBlockerStatus={this.showUiBlocker}
            imageRepository={this.imageRepository}
            showErrors={this.showErrors}
            isMultimediaAd={this.props.isMultimediaAd}
            onImageSelectedByUrl={this.onImageSelectedByUrl}
            logger={getAdCreatorInstrumentation(this.props.instrumentation, this.props.adCreatorScenario).websiteSuggestionActivity}
            onUpdateSubdomainUrl={(newSubdomain) => {
              const subdomainUrl = isEmpty(newSubdomain.trim()) ? this.props.finalUrl : extendPath(finalUrlDomain, newSubdomain);

              this.props.suggestionPoller.getLandingPageSuggestions({
                landingPageUrl: subdomainUrl,
                enableOfflinePollingDelay: false,
                additionalCallback: () => {
                  this.setState({
                    blockSuggestionImagePickerOnly: false,
                  });
                },
                forceInternalScrapingService: !!newSubdomain,
                minimumResolution: {
                  width: this.minimumSize[0],
                  height: this.minimumSize[1],
                },
              });
              this.setState({
                blockSuggestionImagePickerOnly: true,
                forceInternalScrapingService: !!newSubdomain,
                subdomain: newSubdomain,
                fullUrlWithSubdomain: subdomainUrl,
              });
            }}
            finalUrl={this.props.finalUrl}
            finalUrlProtocol={this.props.finalUrlProtocol}
            enableSubdomain
            blockImagePickerOnly={this.state.blockSuggestionImagePickerOnly}
            onUpdateFinalUrlPrefix={this.props.onUpdateFinalUrlPrefix}
            onUpdateFinalUrl={this.props.onUpdateFinalUrl}
            finalUrlDomain={finalUrlDomain}
            initialSubdomain={this.state.subdomain}
            onKeyboardEscapeFromImage={this.onKeyboardEscapeFromImage}
            isLogo={isLogoEnabled && imageOption === C.imageOptionKeys.Logo}
          />
        }
        {
          shouldShowSocialMediaImagePicker && permissions.IsSocialMediaImagesEnabled &&
          <SocialMediaPickerContainer
            repository={this.socialMediaRepository}
            i18n={i18n}
            activityLogger={this.props.activityLogger}
            onImageSelectedByUrl={this.onImageSelectedByUrl}
            onUpdateFinalUrlPrefix={this.props.onUpdateFinalUrlPrefix}
            onUpdateFinalUrl={this.props.onUpdateFinalUrl}
            finalUrlProtocol={this.props.finalUrlProtocol}
            finalUrl={this.props.finalUrl}
          />
        }
        {
          shouldShowFilePicker && previewImageArr.length <= 0 &&
          <ImageFilePicker
            onFileRead={this.onFileRead}
            showErrors={this.showErrors}
            i18n={i18n}
            isMultimediaAd={this.props.isMultimediaAd}
            isAudienceAd={this.props.isAudienceAd}
            enableMultiple={this.enableNewFilePicker && !this.props.isImageExtension}
            enableDrag={this.enableNewFilePicker}
            minimumSize={this.minimumSize}
            hideDescription={this.enableNewFilePicker}
            onFileSelected={this.onFileSelected}
            maxUploadNum={this.getMaxUploadNum()}
          />
        }
        {
          shouldShowFilePicker && this.enableNewFilePicker &&
          <UploadPreview
            assetList={previewImageArr}
            maxUploadNum={this.getMaxUploadNum()}
          />
        }
        {
          this.props.isMultimediaAd &&
          this.state.errors.map((errMsg, index) => (
            <MessageBar
              className="error"
              // eslint-disable-next-line react/no-array-index-key
              key={`${index}`}
              messageBarType={MessageBarType.severeWarning}
              onDismiss={() => this.showErrors([])}
            >
              {errMsg}
            </MessageBar>
          ))
        }
        {
          !this.props.isMultimediaAd &&
          this.state.errors.map((errMsg, index) => (
            <div
              className="error"
              // eslint-disable-next-line react/no-array-index-key
              key={`${index}`}
            >
              {errMsg}
            </div>
          ))
        }
        <div className="add-image-button-bar">
          <button
            className="add-image-cancel-button btn btn-default"
            onClick={this.props.onImageSelectionCanceled}
          >
            {i18n.getString('Audience_Campaign_Cancel_Label')}
          </button>
          {
            isLogoEnabled && imageOption === C.imageOptionKeys.Logo &&
            <AspectRatioChoiceGroup
              i18n={i18n}
              aspectRatioOption={aspectRatioOption}
              landscapeEnabled={this.props.isBusinessLogo}
              onChange={(_, option) => this.props.setAspectRatioOption(option.key)}
            />
          }
          {
            this.props.isThumbsUpDownEnabled && <ThumbsUpDown
              featureArea={this.props.adCreatorScenario.scenarioName}
              isTestEnv={this.props.isTestEnv}
              onThumbsDownSignal={() => feedbackActivity.trace('ThumbsDownSelected;Source=AddImage;')}
              onThumbsUpSignal={() => feedbackActivity.trace('ThumbsUpSelected;Source=AddImage;')}
              containerName="thumbsUpDownAddImage"
            />
          }
        </div>
      </div>);

    const addImageContentVNext = () => (
      <div className="add-image-content-container">
        {addImageContent()}
      </div>);

    const getImageSelectorPanelForVNext = () => (
      this.props.isImageSelectorDisplayed ?
        <Panel
          title={addImageLabelText()}
          isOpen
          onClose={this.props.onImageSelectionCanceled}
          getContainer={getContainer}
          panelClassName={`${this.props.classes.addImageStyle} thumbnail-selector-dialog`}
          i18n={i18n}
          panelReadyAriaLabel={i18n.getString('Add image side panel opened')}
        >
          <UiBlocker
            blocking={this.state.blockUi}
            loadingText={i18n.getString('Loading')}
          >
            {addImageContentVNext()}
          </UiBlocker>
        </Panel> : null);

    const getImageSelectorForThumbnail = () => (
      this.props.isImageSelectorDisplayed ?
        <Dialog
          title={i18n.getString('ImageExperience_EditThumbnailTitle')}
          hidden={false}
          onDismiss={this.props.onImageSelectionCanceled}
          modalProps={{
            className: this.props.classes.addImageStyle,
            layerProps: {
              onLayerDidMount: () => {
                const datasource = this.getDataSource();
                /* istanbul ignore else */
                if (datasource) {
                  datasource.searchAsync(null, this.state.sortBySelection.id, this.props.preDefinedFilter);
                }
              },
            },
          }}
          minWidth={1000}
        >
          <UiBlocker
            blocking={this.state.blockUi}
            loadingText={i18n.getString('Loading')}
          >
            <div className="add-image-content-container image-selector-for-thumbnail">
              <div className="add-image-content" ref={this.dialogRef}>
                <div className="add-image-description">
                  <span>
                    {`${i18n.getString('ImageExperience_AddImageDescription')} `}
                  </span>
                  <LearnMoreLink
                    linkText={i18n.getString('ImageExperience_BestPracticeHelp')}
                    topic="app54659"
                  />
                </div>
                <PillControl
                  className="pill-control"
                  defaultSelectedIndex={pillControlIndex}
                  onItemChange={({ name, value, index }) => this.onPillChange({ name, value, index })}
                  items={this.pillControlItems}
                />
                <div className="clearfix">
                  {
                    shouldShowSearchBox &&
                    <div className={pillControlIndex === 0 ? 'user-image-search-box' : 'user-image-search-box hide'}>
                      <SearchBox
                        onSearch={this.onImageSearch}
                        searchBoxPlacedHolderText={i18n.getString('ImageExperience_Search_Placeholder')}
                        searchBoxAriaLabel={i18n.getString('ImageExperience_Search_Placeholder')}
                      />
                    </div>
                  }
                  {
                    shouldShowSearchBox &&
                    <div className={pillControlIndex === 1 ? 'stock-image-search-box' : 'stock-image-search-box hide'}>
                      <SearchBox
                        onSearch={this.onImageSearch}
                        searchBoxPlacedHolderText={i18n.getString('ImageExperience_Stock_Search_Placeholder')}
                        searchBoxAriaLabel={i18n.getString('ImageExperience_Stock_Search_Placeholder')}
                      />
                    </div>
                  }
                  {
                    shouldShowSortBy &&
                    <div>
                      <div className="dropdown-selector-container">
                        <DropdownSelector
                          totalCount={2}
                          i18n={i18n}
                          selectedItem={sortBySelection}
                          onSelect={this.onSortBySelect}
                          mode="simple"
                          items={this.sortBySelectionItems}
                          dropdownMenuAriaLabel={i18n.getString('ImageExperience_SortBy')}
                          enableArrowKeysSupport={this.props.isForVNext}
                          shouldFocusFirstFocusableItemOnMount
                        />
                      </div>
                      <span className="sort-by-label">
                        {i18n.getString('ImageExperience_SortBy')}
                      </span>
                    </div>
                    }
                </div>
                {
                  shouldShowStockImagePicker && permissions.IsStockPhotoFilterEnabled &&
                  <div className="shutter-stock-filter-container">
                    <StockImageFilter
                      i18n={i18n}
                      i18nLegacy={i18n}
                      isForVNext={isForVNext}
                      onFilterQueryChange={
                        filterQuery => this.stockPhotoDataSource.updateFilterQuery(filterQuery)
                      }
                      popoverContainer={this.dialogRef.current}
                    />
                  </div>
                }
                {
                  shouldShowExistingImagePicker &&
                  <React.Fragment>
                    {
                      this.props.isAdCreatorEnabled &&
                      <div className="alert alert-info">
                        <div className="alert-image" />
                        <div className="alert-info-inline">
                          <span>
                            {i18n.getString('AdCreator_WebsiteImage_OptIn_DisclaimerPartOne')}
                          </span>
                          <a
                            target="_blank"
                            className="btn-link"
                            rel="noopener noreferrer"
                            href="https://about.ads.microsoft.com/en-us/resources/policies/microsoft-advertising-agreement"
                          >
                            <span>{i18n.getString('AdCreator_WebsiteImage_OptIn_DisclaimerPartTwo')}</span>
                          </a>
                          <span>
                            {i18n.getString('AdCreator_WebsiteImage_OptIn_DisclaimerPartThree')}
                          </span>
                          <a
                            target="_blank"
                            className="btn-link"
                            rel="noopener noreferrer"
                            href="https://about.ads.microsoft.com/en-us/resources/policies/image-audio-and-video-policies"
                          >
                            <span>{i18n.getString('ImageExperience_Review_Image_Policy')}</span>
                          </a>
                        </div>
                      </div>
                    }
                    <UserImagePickerContainer
                      imageType={imageType}
                      showUiBlocker={this.showUiBlocker}
                      imageRepository={this.imageRepository}
                      showErrors={this.showErrors}
                      staticImagePath={staticImagePath}
                      userPhotoDataSource={this.userPhotoDataSource}
                      onImageSelected={this.onThumbnailSelected}
                      isForVNext={isForVNext}
                      isLazyLoadEnabled={isLazyLoadEnabled}
                      i18n={i18n}
                      imageList={imageList}
                      isForThumbnail
                    />
                    <ImageFilePicker
                      onFileRead={this.onFileRead}
                      showErrors={this.showErrors}
                      i18n={i18n}
                    />
                  </React.Fragment>
                }
                {
                  shouldShowStockImagePicker &&
                  <React.Fragment>
                    <div className="alert alert-info" style={{ margin: '3px 0' }}>
                      <div className="alert-image" />
                      <div className="alert-info-inline">
                        {i18n.getString('ImageExperience_ShutterStock_Disclaimer_Watermark')}
                      </div>
                    </div>
                    <div className="alert alert-info">
                      <div className="alert-image" />
                      <div className="alert-info-inline">
                        <span>
                          {i18n.getString('ImageExperience_ShutterStock_Disclaimer_Image_Policy')}
                        </span>
                        <span>&nbsp;</span>
                        <a
                          className="HelpTopic btn-link"
                          query="app54718"
                          rel="noopener noreferrer"
                        >
                          <span>{i18n.getString('ImageExperience_Review_Image_Policy')}</span>
                        </a>
                      </div>
                    </div>
                  </React.Fragment>
                }
                {
                  shouldShowStockImagePicker &&
                  <StockImagePickerContainer
                    imageType={imageType}
                    showUiBlocker={this.showUiBlocker}
                    imageRepository={this.imageRepository}
                    showErrors={this.showErrors}
                    onSelectedImagesSet={this.onThumbnailSelected}
                    staticImagePath={staticImagePath}
                    stockPhotoDataSource={this.stockPhotoDataSource}
                    isForVNext={isForVNext}
                    isMultimediaAd={this.props.isMultimediaAd}
                    permissions={this.props.permissions}
                    i18n={i18n}
                    isAdCreatorEnabled={this.props.isAdCreatorEnabled}
                    perfMarker={this.props.perfMarker.createChild('stockImagePicker')}
                    mediaRepository={this.props.mediaRepository}
                    isChooseThumbnail
                  />
                }
                {
                  shouldShowSuggestionPicker &&
                  <ImageSuggestionPickerContainer
                    suggestion={this.props.suggestion}
                    dataSource={this.imageSuggestionDataSource}
                    i18n={i18n}
                    setUiBlockerStatus={this.showUiBlocker}
                    imageRepository={this.imageRepository}
                    showErrors={this.showErrors}
                    isMultimediaAd={this.props.isMultimediaAd}
                    onImageSelectedByUrl={this.onImageSelectedByUrl}
                  />
                }
                {
                  this.state.errors.map((errMsg, index) => (
                    <div
                      className="error"
                      // eslint-disable-next-line react/no-array-index-key
                      key={`${index}`}
                    >
                      {errMsg}
                    </div>
                  ))
                }
              </div>
            </div>
            <DialogFooter>
              <PrimaryButton
                disabled={!this.state.selectedImage}
                onClick={() => this.onImageSelected(
                  this.state.selectedImage,
                  /* istanbul ignore next */
                  shouldShowStockImagePicker? C.imageSources.Stock: C.imageSources.Existing
                )}
              >
                {i18n.getString('Audience_Campaign_Save_Label')}
              </PrimaryButton>
              <DefaultButton
                onClick={this.props.onImageSelectionCanceled}
              >
                {i18n.getString('Cancel')}
              </DefaultButton>
            </DialogFooter>
          </UiBlocker>
        </Dialog> : null);

    if (isChooseThumbnail) {
      return getImageSelectorForThumbnail();
    }

    if (shouldShowContentOnly) {
      return addImageContentVNext();
    }

    return isForVNext ?
      getImageSelectorPanelForVNext() :
      <Modal isModalOpen={this.props.isImageSelectorDisplayed}>
        <UiBlocker
          blocking={this.state.blockUi}
          loadingText={i18n.getString('Loading')}
        >
          {addImageContent()}
        </UiBlocker>
      </Modal>;
  }
}

AddImage.propTypes = {
  isImageSelectorDisplayed: PropTypes.bool,
  onSelectedImagesSet: PropTypes.func.isRequired,
  onImageSelectionCanceled: PropTypes.func.isRequired,
  imageType: PropTypes.string,
  isChooseThumbnail: PropTypes.bool,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
  isForVNext: PropTypes.bool,
  isMultimediaAd: PropTypes.bool,
  isImageExtension: PropTypes.bool,
  isAudienceAd: PropTypes.bool,
  classes: PropTypes.shape({
    addImageStyle: PropTypes.string.isRequired,
  }).isRequired,
  cid: PropTypes.string,
  aid: PropTypes.string.isRequired,
  isStockPhotoEnabled: PropTypes.bool,
  isMultimediaAdinMSANEnabled: PropTypes.bool,
  isLazyLoadEnabled: PropTypes.bool.isRequired,
  oDataConfig: PropTypes.shape({
    odataRootUrl: PropTypes.string,
    odataPath: PropTypes.string,
    odataToken: PropTypes.string,
    applicationName: PropTypes.string,
    oDataTokenType: PropTypes.string,
  }),
  perfMarker: PropTypes.shape({
    willFetchFile: PropTypes.func.isRequired,
    willInit: PropTypes.func.isRequired,
    willFetchData: PropTypes.func.isRequired,
    willRender: PropTypes.func.isRequired,
    done: PropTypes.func.isRequired,
    createChild: PropTypes.func.isRequired,
  }).isRequired,
  staticImagePath: PropTypes.string,
  permissions: PropTypes.shape({
    IsStockPhotoFilterEnabled: PropTypes.bool,
  }),
  getContainer: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  imageList: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.instanceOf(ImageExperienceImage)),
    PropTypes.instanceOf(ImageExperienceImage),
    PropTypes.arrayOf(PropTypes.shape({ IdString: PropTypes.string })),
  ])),
  activityLogger: PropTypes.shape({
    signal: PropTypes.func.isRequired,
  }),
  suggestion: PropTypes.shape({
    images: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string.isRequired,
    })),
    inProgress: PropTypes.bool,
    isTimeout: PropTypes.bool,
    emptyURL: PropTypes.bool,
    invalidURL: PropTypes.bool,
  }),
  suggestionPoller: PropTypes.shape({
    getLandingPageSuggestions: PropTypes.func,
    getMoreLandingPageSuggestions: PropTypes.func,
  }),
  isAdCreatorEnabled: PropTypes.bool,
  isFinalUrlImageRetrievalEnabled: PropTypes.bool,
  isLogoEnabled: PropTypes.bool,
  mediaRepository: PropTypes.instanceOf(MediaRepository),
  shouldShowContentOnly: PropTypes.bool,
  onUpdateFinalUrl: PropTypes.func,
  onUpdateFinalUrlPrefix: PropTypes.func,
  finalUrl: PropTypes.string,
  finalUrlProtocol: PropTypes.string,
  instrumentation: PropTypes.shape({
    addScenario: PropTypes.func,
  }),
  defaultSelectedPill: PropTypes.number,
  adCreatorScenario: PropTypes.shape({
    scenarioName: PropTypes.string,
    scenarioValue: PropTypes.string,
  }),
  maxUploadNum: PropTypes.number,
  imageOption: PropTypes.string,
  imageOptions: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    text: PropTypes.string,
    disabled: PropTypes.bool,
  })),
  setImageOption: PropTypes.func,
  isThumbsUpDownEnabled: PropTypes.bool,
  isTestEnv: PropTypes.bool,
  aspectRatioOption: PropTypes.string,
  setAspectRatioOption: PropTypes.func,
  setProcessExternalImageCallback: PropTypes.func,
  recommendationStockImages: PropTypes.objectOf(PropTypes.any),
  onUploadStart: PropTypes.func,
  onUploadComplete: PropTypes.func,
  isImageExtensionsEnhancementsEnabled: PropTypes.bool,
  isMMAV2Enabled: PropTypes.bool,
  isCombinedMsanAndMmaAspectRatios: PropTypes.bool,
  onSelectStockImage: PropTypes.func,
  isStoreAppProng: PropTypes.bool,
  isStoreAppSpotLight: PropTypes.bool,
  isStoreAppTransparentLogo: PropTypes.bool,
  hideStockPillControl: PropTypes.bool,
  preDefinedFilter: PropTypes.string,
  isLinkedInAd: PropTypes.bool,
  isPMaxAspectRatiosV2Enabled: PropTypes.bool,
};

AddImage.defaultProps = {
  imageType: null,
  isImageSelectorDisplayed: false,
  isForVNext: false,
  isMultimediaAd: false,
  isImageExtension: false,
  isAudienceAd: false,
  cid: '',
  isStockPhotoEnabled: false,
  oDataConfig: null,
  staticImagePath: null,
  permissions: {},
  isChooseThumbnail: false,
  getContainer: 'body',
  imageList: [],
  suggestion: {},
  isMultimediaAdinMSANEnabled: false,
  isAdCreatorEnabled: false,
  isFinalUrlImageRetrievalEnabled: false,
  isLogoEnabled: false,
  mediaRepository: null,
  shouldShowContentOnly: false,
  onUpdateFinalUrl: noop,
  onUpdateFinalUrlPrefix: noop,
  finalUrl: '',
  activityLogger: {
    signal: noop,
  },
  finalUrlProtocol: '',
  suggestionPoller: {
    getLandingPageSuggestions: noop,
    getMoreLandingPageSuggestions: noop,
  },
  instrumentation: {
    addScenario: noop,
  },
  defaultSelectedPill: 0,
  adCreatorScenario: null,
  maxUploadNum: -1,
  imageOption: C.defaultImageOption,
  imageOptions: C.getImageOptions({}),
  setImageOption: noop,
  aspectRatioOption: C.defaultAspectRatioOption,
  setAspectRatioOption: noop,
  isThumbsUpDownEnabled: false,
  isTestEnv: false,
  setProcessExternalImageCallback: noop,
  recommendationStockImages: {},
  onUploadStart: null,
  onUploadComplete: null,
  isImageExtensionsEnhancementsEnabled: false,
  isMMAV2Enabled: false,
  isCombinedMsanAndMmaAspectRatios: false,
  onSelectStockImage: noop,
  isStoreAppProng: false,
  isStoreAppSpotLight: false,
  isStoreAppTransparentLogo: false,
  hideStockPillControl: false,
  preDefinedFilter: '',
  isLinkedInAd: false,
  isPMaxAspectRatiosV2Enabled: false,
};

const AddImageContainer = withInstrumentation(withDefaultStyles(withPerfMarker(AddImage), getAddImageStyle));

export { AddImageContainer, AddImage };
